import { useRef, useEffect } from "react";
import { getAuth, signOut } from "firebase/auth";
import { firebaseApp } from "./firebase";

const auth = getAuth(firebaseApp);

// Make an API request to `/api/{path}`
// export async function apiRequest(path, method = "GET", data) {
//   const accessToken = auth.currentUser
//     ? await auth.currentUser.getIdToken()
//     : undefined;

//     console.log(process.env.REACT_APP_SHOWNAV_API_ENDPOINT)
//     console.log(path)

//   return fetch(`${process.env.REACT_APP_SHOWNAV_API_ENDPOINT}/${path}`, {
//     // return fetch(`../api/${path}`, {
//     method: method,
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${accessToken}`,
//     },
//     body: data ? JSON.stringify(data) : undefined,
//   })
//     .then((response) => {
//       return response.json()
//     })
//     .then((response) => {
//       if (response.status === "error") {
//         // Automatically signout user if accessToken is no longer valid
//         if (response.code === "auth/invalid-user-token") {
//           signOut(auth);
//         }

//         throw new CustomError(response.code, response.message);
//       } else {
//         return response.data;
//       }
//     });
// }
// Make an API request to `/api/{path}`
export async function apiRequest(path, method = "GET", data) {
  const accessToken = auth.currentUser
    ? await auth.currentUser.getIdToken()
    : undefined;

  try {
    const response = await fetch(`${process.env.REACT_APP_SHOWNAV_API_ENDPOINT}/${path}`, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: data ? JSON.stringify(data) : undefined,
    });

    // ✅ Global 401 handler — before parsing JSON
    if (response.status === 401) {
      console.warn("401 Unauthorized — likely expired token. Signing out...");
      await signOut(auth);
      // Optional: redirect to sign-in page
      // window.location.href = "/signin";
      return; // prevent further execution
    }

    const result = await response.json();

    if (result.status === "error") {
      // Handle Firebase invalid token errors, just in case backend sends its own code
      if (result.code === "auth/invalid-user-token") {
        await signOut(auth);
        window.location.href = "/signin";
        return;
      }
      throw new CustomError(result.code, result.message);
    }

    return result.data;
  } catch (err) {
    console.error("API request failed:", err);
    throw err;
  }
}

// Make an API request to any external URL
export function apiRequestExternal(url, method = "GET", data) {
  return fetch(url, {
    method: method,
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data ? JSON.stringify(data) : undefined,
  }).then((response) => response.json());
}

// Create an Error with custom message and code
export function CustomError(code, message) {
  const error = new Error(message);
  error.code = code;
  return error;
}

// Hook that returns previous value of state
export function usePrevious(state) {
  const ref = useRef();
  useEffect(() => {
    ref.current = state;
  });
  return ref.current;
}
